import { render, staticRenderFns } from "./HistoryOrderTabbar.vue?vue&type=template&id=ba9befb6&scoped=true&"
import script from "./HistoryOrderTabbar.vue?vue&type=script&lang=js&"
export * from "./HistoryOrderTabbar.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrderTabbar.vue?vue&type=style&index=0&id=ba9befb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9befb6",
  null
  
)

export default component.exports